import { useMutation } from '@tanstack/react-query';
import { useTranslate } from '@tolgee/react';

import { useToast } from '~/core/contexts/ToastContext';
import { ETolgeeDefault } from '~/shared/enums/ETolgeeDefault';
import { iappApiV1 } from '~/shared/services/api';

function updateLanguage(languageId: string) {
  return iappApiV1.put(`employees/preferred-language/${languageId}`);
}

export function useUpdateLanguage() {
  const { t: tDefault } = useTranslate('default');
  const toast = useToast();

  return useMutation({
    mutationFn: updateLanguage,
    onMutate: () => {
      toast.add({
        title: tDefault(ETolgeeDefault.COMMON_ACTION_UPDATING),
        description: tDefault('languages.preferred_language.updating'),
        type: 'info'
      });
    },
    onSuccess: () => {
      toast.add({
        title: tDefault(ETolgeeDefault.COMMON_ACTION_ACTIONS_SUCCESS),
        type: 'success',
        description: tDefault('languages.preferred_language.success')
      });
    },
    onError: async () => {
      toast.add({
        title: tDefault(ETolgeeDefault.COMMON_ACTION_ACTIONS_ERROR),
        type: 'error',
        description: tDefault('languages.preferred_language.error')
      });
    }
  });
}
